import React from 'react';

import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

import MarkdownField from 'components/fields/MarkdownField';
import { MarkdownButtonPlugin } from 'components/fields/MarkdownField/components';

const propTypes = {
  content: PropTypes.string,
  onMarkdownChange: PropTypes.func.isRequired,
};

const defaultProps = {
  content: '',
};

export default function SingleImageContent({ content, onMarkdownChange }) {
  return (
    <div className="single-image-content">
      <Header content="Content" />
      <MarkdownField
        value={content}
        onChange={onMarkdownChange}
        placeholder="Enter markdown content"
        toolbarPlugins={[MarkdownButtonPlugin]}
        options={{ autoDisplaySideBySidePreview: false }}
      />
    </div>
  );
}

SingleImageContent.propTypes = propTypes;
SingleImageContent.defaultProps = defaultProps;
